<template>
<div ref="head">
  <header class="head">
    <div class="main">
      <div class="head-le">
        <div class="logo mouse" @click="$router.push('/')">
          <img src="../../../assets/images/logo.png" width="92" alt="上海市排球协会">
        </div>
        <div class="logo logo-box">
          <img src="../../../assets/images/logo.png" width="92" alt="上海市排球协会">
        </div>
        <div class="logo2 logo2-h5">
          上海市排球协会
        </div>
        <img class="logo2" src="../../../assets/images/logo2.png" height="24" alt="上海市排球协会" />
      </div>
      <div class="head-ri">
        <input type="text"
          v-model="queryString"
          class="search"
          placeholder="搜索"
          @keyup.enter="searchHandle"
        />
        <div class="lang">
          <span :class="{'action': lang === 'CN'}" @click="langChange('CN')">中</span>
          <span :class="{'action': lang === 'EN'}" @click="langChange('EN')">EN</span>
        </div>
      </div>
      <div class="p-menu">
        <i class="search-icon" @click="$router.push('/search')"></i>
        <img @click="showMenuDrawer" src="../../../assets/images/menu.svg" width="44" height="44" />
      </div>
    </div>
  </header>
  <!-- menu- -->
  <div class="menu" :style="{'fontFamily': lang === 'EN' ? 'Arial/Helvetica' : 'inherit'}">
    <div class="menu-box">
      <div class="item" :style="{'width': `${100 / menus.length}%`}" v-for="(menu, index) in showMenus" :key="index">
        <span @click="$router.push(`${menu.path || '/'}`)">{{ computedName(menu) }}</span>
        <ul v-if="menu.children">
          <li v-for="(child, childIndex) in menu.children" :key="childIndex" @click="menuClick(child)">{{ computedName(child)}}</li>
        </ul>
      </div>
    </div>
  </div>
  <el-drawer
    title="网站导航"
    size="80%"
    :visible.sync="drawer">
    <div class="phone-menu">

      <div class="item" v-for="(menu, index) in showMenus" :key="index">
        <span @click="parentMenuClick(menu)">{{ menu.name }}</span><i class="el-icon-arrow-right"></i>
        <ul v-if="menu.children" :style="{'display': menu.isClick ? 'block' : 'none'}">
          <li v-for="(child, childIndex) in menu.children" @click="menuClick(child)" :key="childIndex">{{ child.name }}</li>
        </ul>
      </div>

    </div>
  </el-drawer>
</div>
</template>
<script>
import { wenzhang, singlePages } from '@/page/constants'
import { getClubList } from '@/service/apis/club'
export default {
  name: 'UiHeader',
  data () {
    return {
      lang: 'CN',  // 1中文，2英文
      queryString: '',
      menus: [
        {
          name: '首 页',
          EnName: 'Home',
          path: '/'
        },
        ...wenzhang,
        ...singlePages
      ],
      drawer: false
    }
  },
  computed: {
    // 显示菜单
    showMenus () {
      let menus = this.menus
      let token = localStorage.getItem('TOKEN')
      if (token) {
        let findIndex = menus.findIndex(item => item.name === '会员专区')
        if (findIndex > 0) {
          menus[findIndex].children[0].name = '个人中心'
          menus[findIndex].children[0].path = '/userinfo'
        }
      }

      return menus
    }
  },
  created() {
    this.lang = sessionStorage.getItem('LANG') || 'CN'
    this.getClubMenu()
  },
  methods: {
    getClubMenu () {
      getClubList.call(this).then(res => {
        if (res.errCode == 0) {
          let clubIndex = this.menus.findIndex(item => item.id === 3) // club === 3
          let { clubList } = res.data
          if (clubList.length) {
            this.menus[clubIndex].children = []
            this.menus[clubIndex].path = `/club?type=${clubList[0].id}`
            clubList.forEach(club => {
              this.menus[clubIndex].children.push({
                id: club.id,
                name: club.clubName,
                EnName: club.enName,
                path: `/club?type=${club.id}`
              })
            })
          }
        }
      })
    },
    langChange(lang) {
      sessionStorage.setItem('LANG', lang)
      this.lang = lang
    },
    searchHandle () {
      if (!this.queryString) {
        this.$message.warn('请输入关键字搜索')
      } else {
        this.$router.push(`/search?type=${this.queryString}`)
      }
    },
    parentMenuClick(menu) {
      if (menu.children && menu.children.length) {
        menu.isClick = !menu.isClick
        return false
      } else {
        this.menuClick(menu)
      }
    },
    menuClick (menu) {
      this.$router.push(`${menu.path || '/'}`)
      this.$refs.head && this.$refs.head.click()
    },
    // 显示菜单语言
    computedName(menu) {
      return this.lang === 'CN' ? menu.name : (menu.EnName || menu.name)
    },
    langClick () {
      this.$refs.head.click()
    },
    showMenuDrawer () {
      this.drawer = true
    },
    handleClose () {}
  }
}
</script>
<style scoped>
.mouse {
  cursor: pointer;
}
input[type=text], textarea {
  outline: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  font-family: "PingFangSC-Medium", "Helvetica Neue",Helvetica,STHeiTi,sans-serif;
}
input[type=text]::-webkit-input-placeholder,
textarea::-webkit-input-placeholder,
input[type=text]::input-placeholder,
textarea::input-placeholder{
  color: #c0c4cc;
}
.mouse { cursor: pointer; }
/* header */
.head {
  position: relative;
  width: 100%;
  height: 88px;
  overflow: hidden;
  background-image: url(../../../assets/images/tt.png);
  background-size: 1920px 88px;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: 1;
}
.head .main {
  max-width: 1280px;
  height: 100%;
  padding: 0 24px;
  margin: 0 auto;
  z-index: 2;
}
.head .head-le {
  padding: 10px 0;
  float: left;
  display: flex;
  align-items: center;
}
.logo2-h5 {
  display: none;
}
.head-le .logo2 {
  margin-left: 22px;
}
.head-ri {
  box-sizing: border-box;
  padding: 0 16px;
  width: 420px;
  float: right;
  text-align: right;
}
.head-ri .lang span {
  color: #fff;
  width: 42px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  display: inline-block;
  border: solid 1px #fff;
  cursor: pointer;
  background-color: #9684e0;
}
.head-ri .lang span.action {
  background-color: #4c2ac9;
}
.head-ri .lang span:first-child {
  border-top-left-radius: 12px;
  border-right: none;
  border-bottom-left-radius: 12px;
}

.head-ri .lang span:last-child {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

.search {
  margin-top: 28px;
  padding: 0 16px 0 48px;
  height: 42px;
  width: 280px;
  box-sizing: border-box;
  border-radius: 8px;
  float: left;
  box-shadow: 12px 0 38px rgba(0, 0, 0, 0.22);
  background-image: url(../../../assets/images/search2.png);
  background-repeat: no-repeat;
  background-position: 16px center;
  background-color: #fff;
}

.p-menu {
  display: none;
}

/* 菜单 */
.menu {
  height: 54px;
  margin-top: 5px;
  background: #4c2ac9;;
}
.menu-box {
  max-width: 1280px;
  margin: 0 auto;
}
.menu-box .item {
  position: relative;
  text-align: center;
  float: left;
  line-height: 54px;
  color: #fefefe;
  font-size: 16px;
  cursor: pointer;
}

.menu-box .item ul {
  display: none;
  width: 100%;
  position: absolute;
  left: 0;
  top: 54px;
  z-index: 1000;
}

.menu-box .item:hover ul {
  display: block;
}

.menu-box .item ul li {
  font-size: 12px;
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  background-color: #5832e5;
}
.menu-box .item ul li:hover {
  background-color: #4c2ac9;
}

.menu-box .item::after {
  width: 1px;
  height: 28px;
  background: #f8f8f8;
  position: absolute;
  content: '';
  right: 0;
  top: 13px;
  display: block;
}

.menu-box .item:last-child::after {
  display: none;
}

.lang {
  margin-top: 42px;
}

.lang-box .line {
  font-size: 14px;
  padding: 8px 0;
  line-height: 30px;
  border-bottom: solid 1px rgba(42, 65, 99, 0.57);
}
.lang-box .line img {
  float: left;
  vertical-align: baseline;
  margin-right: 24px;
}
.lang-box .line:last-child {
  border: none;
}

@media screen and (max-width: 1000px) {
  .head {
    height: 100px;
    background-position: right center;
    background-size: auto 100px;
  }
  .head .main .logo {
    padding: 13px 0;
  }
  .head .main .logo img {
    height: 70px;
    width: auto;
  }
  .head-ri {
    display: none;
  }

  .p-menu {
    position: absolute;
    right: 12px;
    top: 12px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    color: #999;
    display: block;
  }
  .p-menu .search-icon {
      width: 30px;
      height: 30px;
      border-radius: 3px;
      margin: 6px 12px;
      float: left;
      background-color: #846edc;
      background-image: url(../../../assets/images/search.png);
      background-size: 90% 90%;
      background-position: center center;
      background-repeat: no-repeat;
  }
}

::v-deep .phone-menu {
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
}
.logo-box { display: none; }
::v-deep .phone-menu .item {
  overflow-y: scroll;
  color: #333;
  padding: 0 24px;
  font-size: 16px;
  line-height: 44px;
  border-bottom: 1px solid #e1e1e1;
}

::v-deep .phone-menu .item ul {
  display: none;
}

::v-deep .phone-menu .item ul li {
  padding-left: 22px;
}

@media screen and (max-width: 1000px) {
  .logo2 { display: none; }
  .head .head-le {
    padding: 0;
  }
  .menu {
    display: none;
  }
}
@media screen and (max-width: 800px) {
  .logo { display: none; }
  .logo-box {display: block}
  .logo2 {
    display: none;
  }
  .logo2-h5 {
    margin-left: 22px;
    font-size: 22px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    display: block;
  }
  .p-menu {
    top: 28px;
    right: 24px;
  }
  .p-menu .search-icon {
    display: none;
  }
}
</style>
